import { BrutalistBadge, GlassCard, SolidBlock } from "@/app/components/brand-scaffold";
import { hotlineKitchenAnalogy, hotlineComparisonRows } from "@/design-system/registry/homepage";

const glassCardProps = {
  bgClass: "bg-white/75",
  hoverClass: "hover:bg-white/95",
  className: "!p-6 flex flex-col",
} as const;

export function HomepageWhyNotJust() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20 bg-black/[0.04]">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-[#8B5CF6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
            COMPLEMENTARY
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-4">
          为什么不是只用 API、MCP 或 Skills？
        </h2>
        <p className="text-lg font-bold text-zinc-600 mb-10 max-w-3xl">
          它们都有价值，解决的问题不同。Hotline 解决的是另一层：当能力要被发现、调用、版本化、计量和治理时，它需要一个产品化契约。
        </p>

        <div className="grid gap-6 md:grid-cols-2 mb-12">
          <GlassCard {...glassCardProps}>
            <span className="text-2xl">{hotlineKitchenAnalogy.left.emoji}</span>
            <h3 className="font-black text-lg mt-2 mb-1">{hotlineKitchenAnalogy.left.title}</h3>
            <p className="text-sm text-zinc-600 mb-3">{hotlineKitchenAnalogy.left.sub}</p>
            <ul className="space-y-1">
              {hotlineKitchenAnalogy.left.bullets.map((b) => (
                <li key={b} className="text-sm text-zinc-700">• {b}</li>
              ))}
            </ul>
          </GlassCard>
          <SolidBlock bgClass="bg-[#A3E635] text-black" className="!p-6">
            <span className="text-2xl">{hotlineKitchenAnalogy.right.emoji}</span>
            <h3 className="font-black text-lg mt-2 mb-1">{hotlineKitchenAnalogy.right.title}</h3>
            <p className="text-sm text-zinc-800 mb-3">{hotlineKitchenAnalogy.right.sub}</p>
            <ul className="space-y-1">
              {hotlineKitchenAnalogy.right.bullets.map((b) => (
                <li key={b} className="text-sm text-zinc-900">• {b}</li>
              ))}
            </ul>
          </SolidBlock>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-4 border-black text-sm">
            <thead>
              <tr className="bg-black text-white">
                <th className="p-3 text-left font-black">维度</th>
                <th className="p-3 text-left font-black">API</th>
                <th className="p-3 text-left font-black">MCP</th>
                <th className="p-3 text-left font-black">Skills</th>
                <th className="p-3 text-left font-black bg-[#A3E635] text-black">Hotline</th>
              </tr>
            </thead>
            <tbody>
              {hotlineComparisonRows.map((row, idx) => (
                <tr key={row.dimension} className={idx % 2 === 0 ? "bg-white" : "bg-zinc-50"}>
                  <td className="p-3 font-bold border-r-2 border-black">{row.dimension}</td>
                  <td className="p-3 border-r border-zinc-200">{row.api}</td>
                  <td className="p-3 border-r border-zinc-200">{row.mcp}</td>
                  <td className="p-3 border-r border-zinc-200">{row.skill}</td>
                  <td className="p-3 font-bold bg-[#d9f5a8]">{row.hotline}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
